export const Types = {
    GET_USER_GROUPS: "GET_USER_GROUPS",
    SET_USER_GROUPS: "SET_USER_GROUPS",
    ADD_USER_GROUP: "ADD_USER_GROUP",
    UPDATE_USER_GROUP: "UPDATE_USER_GROUP",
    DELETE_USER_GROUP: "DELETE_USER_GROUP",
    GET_PLANTS: "GET_PLANTS",
    SET_PLANTS: "SET_PLANTS",

    GET_USER_GROUP_BY_ID: "GET_USER_GROUP_BY_ID",
    GET_POOL_LIST: "GET_POOL_LIST",
    UPDATE_POOL_USER_GROUP: "UPDATE_POOL_USER_GROUP",
    SET_POOL_USER_GROUP: "SET_POOL_USER_GROUP",
    SET_POOL_LIST: "SET_POOL_LIST",
    SET_USER_GROUP_BY_ID: "SET_USER_GROUP_BY_ID",
    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getUserGroups = () => {
    return {
        type: Types.GET_USER_GROUPS,
    };
};

export const setUserGroups = (payload) => {
    return {
        type: Types.SET_USER_GROUPS,
        payload: payload,
    };
};

export const addUserGroup = (payload) => {
    return {
        type: Types.ADD_USER_GROUP,
        payload: payload,
    };
};

export const updateUserGroup = (payload) => {
    return {
        type: Types.UPDATE_USER_GROUP,
        payload: payload,
    };
};

export const deleteUserGroup = (payload) => {
    return {
        type: Types.DELETE_USER_GROUP,
        payload: payload,
    };
};

export const getPlants = () => ({
    type: Types.GET_PLANTS,
});

export const setPlants = (payload) => ({
    type: Types.SET_PLANTS,
    payload: payload,
});

export const getUserGroupbyID = (payload) => ({
    type: Types.GET_USER_GROUP_BY_ID,
    payload: payload,
});

export const setUserGroupbyID = (payload) => ({
    type: Types.SET_USER_GROUP_BY_ID,
    payload: payload,
});

export const getPoolList = () => ({
    type: Types.GET_POOL_LIST,
});

export const setPoolList = (payload) => ({
    type: Types.SET_POOL_LIST,
    payload,
});

export const updatePoolUserGroup = (payload) => ({
    type: Types.UPDATE_POOL_USER_GROUP,
    payload,
});

export const setPoolUserGroup = (payload) => ({
    type: Types.SET_POOL_USER_GROUP,
    payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
